module.exports = __webpack_public_path__ + "img/lamp_83.29132cd6.jpg";